import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Icon, { ICON_NAME } from "../../../../../../components/Icon";
import Menu from "../../../../../../components/Menu";
import { openPopup } from "../../../../../../components/Popup/_components/WrapperPopup";
import { uuid } from "../../../../../../util/varibles/global";
import { ITaskTreatment, TTaskTreatment } from "../../../../../../util/varibles/interface";
import PopupDuplicate from "../../_components/Duplicate/PopupDuplicate";
import { callEventEditOp, IUnitWhenEdit, useEditOp } from "../../EditOperationContext";
import styles from './style.module.scss';

let isClick = false;
let time = 0;
const initMenu = { open: false, placement: 'bottom' }

interface IProps {
    data: TTaskTreatment

    onDelete?(): void

    onChange(change: Partial<TTaskTreatment>): void
}

const Setting: React.FC<IProps> = (props) => {
    const { data, onDelete } = props;
    const buttonRef = useRef<HTMLDivElement>(null);
    const [menu, setMenu] = useState(initMenu);
    const [site, set] = useEditOp(state => state.site);
    const { turnOnCalculate } = callEventEditOp()
    const turnOnCalculateRef = useRef(turnOnCalculate);

    useEffect(() => {
        turnOnCalculateRef.current = turnOnCalculate;
    }, [turnOnCalculate]);

    const items = useMemo(() => [
        {
            key: 'duplicate',
            onClick: () => {
                setMenu(prev => ({ ...prev, open: false }));
                const { sub_operation } = data;
                const modal = openPopup(<PopupDuplicate
                    isShow={true}
                    sites={site ? [site] : []}
                    unit={sub_operation}
                    onAdd={units => {
                        set(({ units: prev }) => ({
                            units: units.reduce((rs: { [id: string]: IUnitWhenEdit }, item) => ({
                                ...rs,
                                [item.id]: {
                                    ...rs[item.id],
                                    tasks: [...rs[item.id].tasks || [], {
                                        ...data,
                                        group_id: uuid(),
                                        sub_operation: item
                                    }] as ITaskTreatment[]
                                }
                            }), prev)
                        }))
                        turnOnCalculateRef.current();
                    }}
                    onClose={() => modal.remove()}
                />);
            },
            label: <div className='menu-line'>
                <Icon icon={ICON_NAME.DUPLICATE} />
                <span>Replicate to other unit</span>
            </div>
        },
        {
            key: 'delete',
            onClick: onDelete,
            label: <div className='menu-line' data-danger='true'>
                <Icon icon={ICON_NAME.DELETE} danger />
                <span>Delete task</span>
            </div>
        }
    ], [data, site, set, onDelete]);

    const handleMouseDown = useCallback((e: any) => {
        setMenu({ ...menu, placement: 'bottomRight' });
        if (buttonRef.current) {
            isClick = true;
            const { x, y } = e.target.getBoundingClientRect();
            const event = new MouseEvent("contextmenu", {
                bubbles: true,
                cancelable: false,
                view: window,
                button: 2,
                buttons: 0,
                clientX: x + 28,
                clientY: y + 28
            });
            buttonRef.current.dispatchEvent(event);
        }
    }, [menu]);

    const onOpenChange = useCallback((value: boolean) => {
        const state = { open: value, placement: '' };
        if (isClick) {
            state.placement = 'bottomRight'
            isClick = false;
        } else if ((Date.now() - time) < 5) {
            return;
        }
        setMenu(state);
    }, [])

    return <Menu
        visible={menu.open}
        placement={menu.placement as any}
        onOpenChange={onOpenChange}
        items={items}
        trigger={['contextMenu']}
    >
        <div ref={buttonRef} className={styles.button}>
            <div className='three-dot' onMouseDown={handleMouseDown} onMouseUp={() => time = Date.now()} />
        </div>
    </Menu>;
};

export default Setting;
